import React, { useEffect } from 'react';
import { useParams } from 'react-router-dom';
import Achievements from './Achievements';
import HeroSection from './HeroSection';
import Card from './Card';
import Owl from './Owl';
import Services from './Services';
import Technologies from './Technologies';
import { Helmet } from 'react-helmet';

const DataAnalytics = (props) => {
    const { slug } = useParams()
    // =========================== scroll To Top default =========================
    useEffect(() => {
        props.demo('top')
    }, [slug])
    // =========================== scroll To Top default =========================
    return (
        <>
            <Helmet>
                <title>Data Analytics Services – Infograins</title>
                <meta name="description" content="Our Data Analytics Services and Solutions are geared towards enabling clients to convert data into insights that drive maximum business profits." />
            </Helmet>
            <HeroSection />
            <Achievements />
            <Services />
            <Technologies />
            <Owl />
            <Card />
        </>
    )
}

export default DataAnalytics